// src/pages/CalculoHonorarios/components/DadosGerais.js

import React, { useState } from 'react';
import axios from 'axios';

const DadosGerais = ({ formData, onChange }) => {
  const [buscandoCliente, setBuscandoCliente] = useState(false);
  const [erroCliente, setErroCliente] = useState('');

  const buscarNomeCliente = async (codigo) => {
    if (!codigo) {
      onChange('nome_cli', '');
      setErroCliente('');
      return;
    }

    const codigoFormatado = String(codigo).padStart(5, '0');
    setBuscandoCliente(true);
    setErroCliente('');

    try {
      const response = await axios.get(`/api/clients/${codigoFormatado}`);
      if (response.data.success && response.data.data?.Nome) {
        onChange('nome_cli', response.data.data.Nome);
        setErroCliente('');
      } else {
        onChange('nome_cli', '');
        setErroCliente('Cliente não encontrado');
      }
    } catch (err) {
      console.error('Erro ao buscar nome do cliente:', err);
      onChange('nome_cli', '');
      setErroCliente('Erro ao buscar cliente');
    } finally {
      setBuscandoCliente(false);
    }
  };

  const handleCodCliChange = (e) => {
    const newVal = e.target.value ? parseInt(e.target.value) : null;
    onChange('cod_cli', newVal);
    if (!newVal) {
      onChange('nome_cli', '');
      setErroCliente('');
    }
  };

  return (
    <div className="formulario-secao">
      <h3>📋 Parte 1 — Dados Gerais</h3>

      <div className="form-row">
        <div className="form-group">
          <label className="field-label">
            <span>👤</span>
            Código do Cliente (opcional)
          </label>
          <input
            type="number"
            value={formData.cod_cli || ''}
            onChange={handleCodCliChange}
            onBlur={(e) => buscarNomeCliente(e.target.value ? parseInt(e.target.value) : null)}
            placeholder="Ex: 7919"
            className="form-input"
          />
          {buscandoCliente && (
            <span className="client-lookup-info">⏳ Buscando cliente...</span>
          )}
          {!buscandoCliente && formData.nome_cli && (
            <span className="client-lookup-info client-found">✅ {formData.nome_cli}</span>
          )}
          {!buscandoCliente && erroCliente && (
            <span className="client-lookup-info client-error">⚠️ {erroCliente}</span>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="field-label">
            <span>⏱️</span>
            Total de Horas
          </label>
          <input
            type="number"
            min="0"
            step="0.5"
            value={formData.base_total_horas || ''}
            onChange={(e) => onChange('base_total_horas', parseFloat(e.target.value) || 0)}
            placeholder="Ex: 20"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label className="field-label">
            <span>💶</span>
            Valor por Hora (€)
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={formData.base_valor_hora || ''}
            onChange={(e) => onChange('base_valor_hora', parseFloat(e.target.value) || 0)}
            placeholder="Ex: 80.00"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label className="field-label">
            <span>💰</span>
            Valor Base (automático)
          </label>
          <input
            type="text"
            value={`${((formData.base_total_horas || 0) * (formData.base_valor_hora || 0)).toFixed(2)} €`}
            className="form-input"
            disabled
          />
        </div>
      </div>

      <div className="form-group">
        <label className="field-label">
          <span>📝</span>
          Descrição do Trabalho Realizado <span className="required">*</span>
        </label>
        <textarea
          value={formData.descricao_servico || ''}
          onChange={(e) => onChange('descricao_servico', e.target.value)}
          placeholder="Descreva detalhadamente o trabalho realizado..."
          className="form-textarea"
          rows="4"
          required
        />
      </div>
    </div>
  );
};

export default DadosGerais;